import { render, staticRenderFns } from "./InboxContentCommLog.vue?vue&type=template&id=33e200e8&scoped=true&"
import script from "./InboxContentCommLog.vue?vue&type=script&lang=js&"
export * from "./InboxContentCommLog.vue?vue&type=script&lang=js&"
import style0 from "./InboxContentCommLog.vue?vue&type=style&index=0&id=33e200e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e200e8",
  null
  
)

export default component.exports